import cookie from 'utils/cookie';
import { COOKIE_KEYS } from 'consts/cookieKeys';

export const setInviteToken = (token: string) => {
  cookie.set(COOKIE_KEYS.invite, token);
};

export const captureReferrerUrl = () => {
  if (!cookie.has(COOKIE_KEYS.referrerUrl)) {
    // take first 1000 characters to limit cookie overflow
    const referrerUrl = document.referrer.substring(0, 1001);
    cookie.set(COOKIE_KEYS.referrerUrl, referrerUrl);
  }
};

export const captureLandingPageUrl = () => {
  if (!cookie.has(COOKIE_KEYS.lpUrl)) {
    // take first 1000 characters to limit cookie overflow
    const landingPageUrl = window.location.href.substring(0, 1001);
    cookie.set(COOKIE_KEYS.lpUrl, landingPageUrl);
  }
};

export const captureClickedCtaPageUrl = () => {
  // Limits to 1,000 characters to help prevent a cookie overflow.
  const clickedCtaPageUrl = window.location.href.substring(0, 1000);
  cookie.set(COOKIE_KEYS.clickedCtaPageUrl, clickedCtaPageUrl);
};
